import { z } from 'zod'

import { ConfirmationRequestStatus } from '../constants/confirmationRequest'
import { InventoryType } from '../constants/inventory'
import { personDisplaySchema } from './personDisplay'

/** Tier-level sales summary returned with each inventory stat row */
export const inventoryStatTierSummarySchema = z.object({
  name: z.string().nullish(),
  location: z.string().nullish(),
  price: z.coerce.number(),
  quantity: z.coerce.number(),
  quantityTotal: z.coerce.number(),
  quantitySold: z.coerce.number(),
  percentSold: z.coerce.number(),
  guestsCheckedIn: z.coerce.number().nullish(),
  guestsExpected: z.coerce.number().nullish(),
  reservationsCheckedIn: z.coerce.number().nullish(),
  reservationsExpected: z.coerce.number().nullish(),
  guestsExpectedMale: z.coerce.number().nullish(),
  guestsExpectedFemale: z.coerce.number().nullish(),
  guestsExpectedUnisex: z.coerce.number().nullish(),
})

export const inventoryStatPaymentLinkSchema = z.object({
  id: z.string(),
  status: z.nativeEnum(ConfirmationRequestStatus),
  name: z.string().nullish(),
  clientName: z.string().nullish(),
  admissionGroupId: z.string(),
  link: z.string().nullish(),
  paymentAmount: z.coerce.number(),
  created: z.coerce.date(),
  createdBy: personDisplaySchema.optional().nullable(),
})

/** Single inventory row with sales stats (venue inventory-stats endpoint) */
export const inventoryStatItemSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  location: z.string().nullish(),
  type: z.nativeEnum(InventoryType),
  price: z.coerce.number().nullish(),
  quantity: z.coerce.number().nullish(),
  quantityTotal: z.coerce.number().nullish(),
  quantitySold: z.coerce.number().nullish(),
  percentSold: z.coerce.number().nullish(),
  guestsCheckedIn: z.coerce.number().nullish(),
  guestsExpected: z.coerce.number().nullish(),
  reservationsCheckedIn: z.coerce.number().nullish(),
  reservationsExpected: z.coerce.number().nullish(),
  guestsExpectedMale: z.coerce.number().nullish(),
  guestsExpectedFemale: z.coerce.number().nullish(),
  guestsExpectedUnisex: z.coerce.number().nullish(),
  pickUpStart: z.coerce.date().nullish(),
  pickUpEnd: z.coerce.date().nullish(),
  pickUpType: z.string().nullish(),
  isPaymentLink: z.boolean().optional(),
  paymentLink: inventoryStatPaymentLinkSchema.nullish().optional(),
  tiers: z.array(inventoryStatTierSummarySchema).nullable().optional(),
})

/** Query params for GET /v1/venues/:venueId/inventory-stats/:inventoryStatId */
export const inventoryStatListQuerySchema = z.object({
  type: z
    .nativeEnum(InventoryType)
    .or(z.array(z.nativeEnum(InventoryType)))
    .optional(),
  sort: z.string().optional(),
  quantityMin: z.coerce.number().optional(),
})
